import { Body1, Header2, modalPadding, narrowPadding, styled } from "@iventis/styles";
import { Content } from "@iventis/translations";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import React from "react";

export const ScheduleConfigNoPermission: React.FC = () => {
    const translate = useIventisTranslate();

    return (
        <StyledDiv>
            <Header2>{translate(Content.schedule2.scheduleDoesntExist.createTitle)}</Header2>
            <Body1>{translate(Content.schedule2.scheduleDoesntExist.noPermission)}</Body1>
        </StyledDiv>
    );
};

const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: ${modalPadding};

    h2 {
        margin-bottom: ${narrowPadding};
    }
`;
